import { faCreditCard } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getCardIcon from 'hooks/useCardIcon';
import { FunctionComponent } from 'react';
import { CardOnFile } from '@spike/payments-model';
import Spinner from 'components/UI/V3/Spinner';
import { Popup } from '../../UI/ListPetInfo/Popup/Popup';
import styles from './CardOnFileIndicator.module.scss';

interface CardOnFileIndicatorProps {
    cards: CardOnFile[];
    isLoading: boolean;
    showBelow?: boolean;
}

export const CardOnFileIndicator: FunctionComponent<CardOnFileIndicatorProps> = ({
    cards,
    isLoading,
    showBelow = false
}) => {
    if (isLoading) {
        return (
            <div
                className={styles.loading}
                aria-label="Loading cards on file"
            >
                <Spinner size={16} />
            </div>
        );
    }

    if (cards.length === 0) return null;

    const content = (
        <div className={styles.popover}>
            <span className={styles.title}>Card on File</span>
            <div className={styles.cards}>
                {cards.map((card, index) => (
                    <div
                        className={styles.card}
                        key={`${card.brand}-${card.last4}-${index}`}
                    >
                        <img
                            className={styles.brand}
                            src={getCardIcon(card.brand)}
                            alt={card.brand || 'Card'}
                        />
                        <span className={styles.number}>•••• {card.last4}</span>
                        <span className={card.expired ? styles.expired : undefined}>
                            Exp. {String(card.expirationMonth).padStart(2, '0')}/{card.expirationYear}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <Popup
            content={content}
            placement={showBelow ? 'bottom' : 'top'}
            className={styles.popup}
        >
            <button
                type="button"
                className={styles.indicator}
                aria-label="View cards on file"
            >
                <FontAwesomeIcon icon={faCreditCard} />
            </button>
        </Popup>
    );
};
